import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function ScheduleCheckSongsHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none">
                <Col xs onClick={() => requestSort("artist")}>
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs onClick={() => requestSort("title")}>
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} onClick={() => requestSort("scheduled_start")}>
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Scheduled At</span>
                        <span className="col-1">{renderSortIcon("scheduled_start", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} onClick={() => requestSort("logged_start")}>
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Played At</span>
                        <span className="col-1">{renderSortIcon("logged_start", sortConfig)}</span>
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
}
